export default __webpack_public_path__ + "static/media/2223.047592d0.png";